/* eslint react/no-array-index-key: 1 */
import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import {
    Grid,
    Table as MaterialTable,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    Menu,
    IconButton,
} from '@material-ui/core';
import FilterIcon from '@material-ui/icons/FilterList';

import TableFilters from 'Console/components/common/Table/TableFilters';

import EnhancedTableHead from './EnhancedTableHead';
import { stableSort, getSorting } from './tableHelpers';

const styles = (theme) => ({
    filterIcon: {
        position: 'absolute',
        top: -10,
        right: 0,
        'z-index': 10,
    },
    pagination: {
        marginLeft: 'auto',
        fontSize: theme.typography.pxToRem(12),
    },
    paginationSelect: {
        paddingRight: theme.typography.pxToRem(20),
    },
    tableWrapper: {
        position: 'relative',
        width: '100%',
    },
    table: {
        overflow: 'auto',
    },
});

const extractOptions = (props) => {
    const { options } = props;
    return options;
};

class Table extends PureComponent {
    static defaultProps = {
        options: { pagination: {} },
    };

    state = {
        activeFilters: {
            search: {
                global: '',
            },
            date: {},
            dropdown: {},
            multiselect: {},
        },
        orderBy: extractOptions(this.props).initialOrderBy || '',
        order: extractOptions(this.props).initialOrder || 'desc',
        page: 0,
        rowsPerPage: extractOptions(this.props).pagination.rowsPerPage || 20,
        anchorEl: null,
    };

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const newOrderBy = property;
        let newOrder = 'desc';

        const {orderBy, order} = this.state;

        if (orderBy === property && order === 'desc') {
            newOrder = 'asc';
        }

        this.setState({ 
                order: newOrder, 
                orderBy: newOrderBy 
            });
    };

    handleChangeFilter = (type, key, value) => {
        const { activeFilters } = this.state;

        this.setState({
            activeFilters: {
                ...activeFilters,
                [type]: { ...activeFilters[type], [key]: value },
            },
        });
    };

    applySearchFilter = (row) => {
        const { activeFilters: { search } } = this.state;
        const searchKeys = Object.keys(search);
        let dispalyRow = true;

        if (search.global) {
            const matchField = Object.values(row).find((cell) => cell.includes(search.global));

            return Boolean(matchField);
        }

        searchKeys.forEach((key) => {
            const searchValue = search[key];
            const cellValue = row[key];
            dispalyRow = cellValue ? cellValue.toString().includes(searchValue) : true;
        });

        return dispalyRow;
    };

    applyDateFilter = (row) => {
        const { activeFilters: { date }} = this.state;
        const { columns } = this.props;
        const dateKeys = Object.keys(date);
        let dispalyRow = true;

        dateKeys.forEach((key) => {
            const columnIndex = columns.findIndex((column) => column.fieldName === key);
            const { dateFormat } = columns[columnIndex];

            const cellValue = moment(row[key], dateFormat).toDate();

            dispalyRow = moment(moment(cellValue)).isBetween(
                moment(date[key].gte),
                moment(date[key].lte)
            );
        });

        return dispalyRow;
    };

    applyDropdownFilter = (row) => {
        const { activeFilters: { dropdown }} = this.state;
        const dropdownKeys = Object.keys(dropdown);
        let dispalyRow = true;

        dropdownKeys.forEach((key) => {
            const cellValue = row[key];
            const dropDownValue = dropdown[key];

            if (!dropDownValue) {
                dispalyRow = true;
                return;
            }

            dispalyRow = cellValue === dropDownValue;
        });

        return dispalyRow;
    };

    applyMultiselectFilter = (row) => {
        const { activeFilters: { multiselect }} = this.state;
        const multiselectKeys = Object.keys(multiselect);
        let dispalyRow = true;

        multiselectKeys.forEach((key) => {
            if (multiselect[key].length === 0) {
                return;
            }

            const cellValue = row[key];
            const multiselectValue = multiselect[key];
            dispalyRow = multiselectValue.includes(cellValue);
        });

        return dispalyRow;
    };

    // @TODO refactor this to use common logic,
    // there is  no time for that now
    shouldDispalyRow = (row) => {
        if (
            this.applyDropdownFilter(row) &&
            this.applyMultiselectFilter(row) &&
            this.applyDateFilter(row) &&
            this.applySearchFilter(row)
        ) {
            return true;
        }
        return false;
    };

    render() {
        const { classes, columns, data, filters, options } = this.props;
        const { activeFilters, order, orderBy, rowsPerPage, page, anchorEl } = this.state;

        return (
            <Grid className={classes.tableWrapper}>
                <Grid className={classes.table} ref={this.tableWrapper}>
                    <IconButton
                        aria-label="More"
                        aria-owns={anchorEl ? 'long-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                        className={classes.filterIcon}
                    >
                        <FilterIcon />
                    </IconButton>

                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}
                    >
                        <TableFilters
                            activeFilters={activeFilters}
                            filters={filters}
                            onChange={this.handleChangeFilter}
                        />
                    </Menu>

                    <MaterialTable className={classes.table}>
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={data.length}
                            columns={columns}
                        />

                        <TableBody>
                            {stableSort(data, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    if (!this.shouldDispalyRow(row)) {
                                        return null;
                                    }

                                    return (
                                        <TableRow
                                            key={index}
                                            onClick={
                                                options.actions &&
                                                options.actions.rowClick &&
                                                options.actions.rowClick(row)
                                            }
                                        >
                                            {Object.keys(row).map((key, index) => {
                                                if (
                                                    options &&
                                                    options.dataToIgnore &&
                                                    !options.dataToIgnore.includes(key)
                                                ) {
                                                    return <TableCell key={index}>{row[key]}</TableCell>;
                                                }

                                                if (options && !options.dataToIgnore) {
                                                    return <TableCell key={index}>{row[key]}</TableCell>;
                                                }
                                                return null;
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </MaterialTable>
                </Grid>

                {options.pagination.allowed !== false && (
                    <TablePagination
                        className={classes.pagination}
                        rowsPerPageOptions={options.pagination.rowsPerPageOptions || [5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        classes={{
                            select: classes.paginationSelect,
                        }}
                    />
                )}
            </Grid>
        );
    }
}

export default withStyles(styles)(injectIntl(Table));
